import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';
import { StyledProps, ToastTypes } from './Toast.types';

export const ToastContainer = styled.div`
  position: absolute;
  top: ${rem(16)};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: none;
`;

export const ToastElementContainer = styled.div<StyledProps>`
  margin: ${rem(16)};
  display: flex;
  align-items: center;
  position: relative;
  top: 0;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.3);
  border-radius: ${rem(8)};
  padding: ${rem(16)} ${rem(16)} ${rem(16)} ${rem(34)};
  height: max-content;
  max-width: ${rem(600)};
  min-width: ${rem(480)};
  z-index: 5;
  background-color: ${({ theme }) => theme.colors.white};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: all 0.8s ease;
  animation-duration: 1s;
  animation-name: fadein;
  pointer-events: auto;

  @keyframes fadein {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  //* colored bar on the left */
  &:before {
    position: absolute;
    border-radius: ${rem(8)} 0 0 ${rem(8)};
    left: 0;
    height: 100%;
    content: '';
    width: ${rem(10)};
    background-color: ${({ theme, type }) => {
      switch (type) {
        case ToastTypes.Error:
          return theme.colors.red;
        case ToastTypes.Info:
          return theme.colors.blue;
        default:
          return theme.colors.green;
      }
    }};
  }
  //* grey vertical divider */
  &:after {
    position: absolute;
    right: ${rem(72)};
    height: 60%;
    content: '';
    width: 2px;
    background-color: ${({ theme }) => theme.colors.gray600};
    opacity: 0.3;
  }
`;

export const IconAndMessage = styled.div`
  display: flex;
  align-items: flex-start;
  flex-grow: 1;

  svg {
    font-size: 28px;
  }
`;

export const ButtonWrapper = styled.div`
  width: max-content;
`;

export const MessageContainer = styled.div`
  font-family: 'Open Sans';
  font-size: ${rem(18)};
  font-weight: 700;
  line-height: ${rem(22)};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-left: ${rem(8)};
  padding-right: ${rem(24)};
`;

export const Message = styled.div`
  padding-left: ${rem(8)};
  margin: ${rem(2)} 0;
`;

export const Subtext = styled.div`
  padding-left: ${rem(8)};
  font-weight: 400;
  font-size: ${rem(14)};
  margin: ${rem(2)} 0;
  white-space: pre-wrap;
`;

export const CloseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: ${rem(28)};
  width: ${rem(44)};
  height: ${rem(44)};
  margin-left: ${rem(16)};
  color: ${({ theme }) => theme.colors.gray600};

  &:focus {
    outline: none;
  }
  &:focus svg {
    ${({ theme }) => theme.states.focus};
  }
`;
